import httpClient from './httpClient'

const END_POINT = '/api/localizacions'

const getLocalizaciones = async () => await httpClient.get(END_POINT)

export {
  getLocalizaciones,
}
